<template>
    <Main>
        <div slot="main" class="main user">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
            </div>
            <div class="content">
                正在开发中
            </div>
        </div>
    </Main>
</template>

<script>
import Main from "@/components/main.vue";
import Header from "../../components/header.vue";
import HighCharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(HighCharts);
export default {
    components: {
        Main,
        Header,
    },
    data() {
        return {
            headerInfo: {},
            userInfo: {},
        };
    },
    created() {
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
    },
}
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    height: 100%;

    .content {
        // height: 12.08rem;
        height: calc(100vh - 1rem);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.23rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #FFFFFF;
        background-image: url("../../assets/bg-hhr.png");
        background-size: 100% 100%;
    }
}
</style>